import classNames from 'classnames';
import type { OncallResponse } from 'types/api-responses';
import styles from './report-form.module.scss';

interface OncallLineProps {
  oncall: Extract<OncallResponse, { state: 'ok' }>;
  /** Lets a caller drop the form's bottom margin when the line sits in a header. */
  className?: string;
}

/**
 * "On-call engineer this week: <name> · <place>", with the place written out ("India",
 * "United States") rather than the code, so nothing needs a hover to be understood.
 *
 * @param {OncallLineProps} props
 * @param {object} props.oncall This week's on-call engineer, once there is one to show.
 * @param {string} [props.className] Extra class for the paragraph.
 * @return {JSX.Element} The line.
 */
export function OncallLine({ oncall, className }: OncallLineProps) {
  return (
    <p className={classNames(styles.oncall, className)}>
      On-call engineer this week:{' '}
      <span className={styles.oncallName}>{oncall.name}</span> ·{' '}
      {oncall.location}
    </p>
  );
}
